import { memo } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Dispatch } from 'redux';
import { Button, FlexboxGrid, Modal } from 'rsuite';
import { RootState } from '../@types/RootState';
import { selectorNavBarModals, SET_IS_OPEN } from '../reducers/navBar/modals';

type ModalNoAccessInfoPanelProps = RouteComponentProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> & {
    show: boolean;
  };

const ModalNoAccessInfoPanel = ({ show, onHide, history }: ModalNoAccessInfoPanelProps) => (
  <Modal className="modal-no-access-infopanel" size="sm" show={show} onHide={onHide}>
    <Modal.Header>
      <Modal.Title>Acesso restrito</Modal.Title>
    </Modal.Header>
    <Modal.Body className="description">
      <FlexboxGrid>
        <p>
          Você ainda não tem acesso ao InfoPanel. Gostaria de experimentar a versão <b>Free</b>?
        </p>
      </FlexboxGrid>
    </Modal.Body>
    <Modal.Footer>
      <Button block onClick={() => history.push('/free/configuracoes')} appearance="primary">
        Cadastrar
      </Button>
    </Modal.Footer>
  </Modal>
);

const mapStateToProps = (state: RootState) => ({
  show: selectorNavBarModals(state).PAN,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onHide: () => dispatch(SET_IS_OPEN({ key: 'PAN', payload: false })),
});

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalNoAccessInfoPanel)));
